<div class="close-dialog-holder">
  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    class="close-dialog-button">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<form (ngSubmit)="send()" [formGroup]="form">
  @if (step === stepEnum.Deal) {
    @if (workloadIndicator.isNotLoading | async) {
      <mat-dialog-content class="payment-dialog__body">
        <p>
          <strong>{{
            'schedule-payment.component.which_commission_received'
              | localise: 'Which commission have you received?'
          }}</strong>
        </p>
        <mat-button-toggle-group
          formControlName="selectedDeal"
          (change)="onChangeDeal($event)">
          @for (deal of deals || []; track deal) {
            <mat-button-toggle [value]="deal.id">
              <!--            <span class="category">Closes {{deal.paymentDate | dateApp: formatDateEnum.DDMMM}}</span>-->
              <span class="value">{{ deal.line1Address }}</span>
            </mat-button-toggle>
          }
          <mat-button-toggle [value]="-1" class="mat-button-toggle--bottom">
            <!--            <span class="category">No Deal</span>-->
            <span class="value">{{
              'schedule-payment.component.make_payment_button'
                | localise: 'I just want to make a payment'
            }}</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </mat-dialog-content>
    }
    @if (workloadIndicator.isLoading | async) {
      <img
        src="../../../../assets/img/dashboard/loading_payment.png"
        alt="Loading" />
    }
    @if (error) {
      <p class="p-error-message p-error-message--margin">
        {{ error }}
      </p>
    }
    @if (workloadIndicator.isNotLoading | async) {
      <mat-dialog-actions class="payment-dialog__actions">
        <button
          mat-button
          cdkFocusInitial
          type="button"
          class="dialog-button dialog-button--primary dialog-button--round arrow-payment-dialog"
          [disabled]="workloadIndicator.isLoading | async"
          (click)="setStep(stepEnum.Date)">
          @if (workloadIndicator.isNotLoading | async) {
            <mat-icon>arrow_forward</mat-icon>
          }
          @if (workloadIndicator.isLoading | async) {
            <mat-spinner class="loader" [diameter]="25"></mat-spinner>
          }
        </button>
      </mat-dialog-actions>
    }
  }

  @if (step === stepEnum.Date) {
    <mat-dialog-content class="payment-dialog__body">
      <p>
        <strong>{{
          'schedule-payment.component.choose_payment_date'
            | localise: 'Choose Payment Date'
        }}</strong>
      </p>
      <mat-button-toggle-group
        class="{{ themesService.themeClass }}"
        [(value)]="dateVariant"
        [disabled]="workloadIndicator.isLoading | async">
        <mat-button-toggle
          [matTooltip]="
            allowPayTodayExpire <= 0
              ? 'Available every day until 5pm Eastern Time'
              : ''
          "
          [value]="dateVariantEnum.today"
          [disabled]="allowPayTodayExpire <= 0"
          (change)="setDateToday()">
          <span class="value">{{
            'schedule-payment.component.today_button' | localise: 'Today'
          }}</span>
        </mat-button-toggle>
        <mat-button-toggle
          class="{{ themesService.themeClass }}"
          [value]="dateVariantEnum.tomorrow"
          [class.mat-button-toggle--100]="tomorrowDate === closingDate"
          (change)="setDateTomorrow()">
          <!--          <span class="category">Tomorrow</span>-->
          <span class="value"
            >{{
              'schedule-payment.component.tomorrow_button'
                | localise: 'Tomorrow -'
            }}
            {{ tomorrowDate | dateApp: formatDateEnum.DDMMM }}</span
          >
        </mat-button-toggle>
        <mat-button-toggle
          [value]="dateVariantEnum.origin"
          [hidden]="tomorrowDate === closingDate"
          (change)="setPaymentDate()">
          <!--          <span class="category">Due Date</span>-->
          <span class="value"
            >{{
              'schedule-payment.component.deal_due_date_button'
                | localise: 'Deal Due Date -'
            }}
            {{ closingDate | dateApp: formatDateEnum.DDMMM }}</span
          >
        </mat-button-toggle>
        <mat-button-toggle
          class="mat-button-toggle--bottom {{ themesService.themeClass }}"
          (change)="onDateVariantCustom()"
          [value]="dateVariantEnum.custom">
          <span class="value">{{
            'schedule-payment.component.other_button' | localise: 'Other'
          }}</span>
          @if (dateVariant === dateVariantEnum.custom) {
            <app-day-input
              #dateInput
              formControlName="date"
              [min]="minPaymentDate"
              [appDisableAutofill]="true"></app-day-input>
          }
          @if (dateVariant !== dateVariantEnum.custom) {
            <app-day-input class="skip-events"></app-day-input>
          }
        </mat-button-toggle>
      </mat-button-toggle-group>
    </mat-dialog-content>
    @if (error) {
      <p class="p-error-message p-error-message--margin">
        {{ error }}
      </p>
    }
    <mat-dialog-actions class="payment-dialog__actions">
      @if (!withoutSelectingDeal) {
        <button
          mat-button
          type="button"
          class="dialog-button dialog-button--round"
          [disabled]="workloadIndicator.isLoading | async"
          (click)="setStep(stepEnum.Deal)">
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      <button
        mat-button
        cdkFocusInitial
        type="button"
        class="dialog-button dialog-button--primary dialog-button--round"
        [disabled]="
          (workloadIndicator.isLoading | async) || !form.controls.date.value
        "
        (click)="setStep(stepEnum.Amount)">
        @if (workloadIndicator.isNotLoading | async) {
          <mat-icon>arrow_forward</mat-icon>
        }
        @if (workloadIndicator.isLoading | async) {
          <mat-spinner class="loader" [diameter]="25"></mat-spinner>
        }
      </button>
    </mat-dialog-actions>
  }

  @if (step === stepEnum.Amount) {
    <mat-dialog-content class="payment-dialog__body">
      <!--      <p class="payment__summary">You're scheduling a payment on <span>{{form.controls.date.value | dateApp: formatDateEnum.DDMMMYYYY}}</span></p>-->
      <p>
        <strong>{{
          'schedule-payment.component.choose_payment_amount'
            | localise: 'Choose Payment Amount'
        }}</strong>
      </p>
      <mat-button-toggle-group
        [value]="amountVariant"
        (valueChange)="onAmountVariantChange($event)"
        [disabled]="workloadIndicator.isLoading | async">
        <mat-button-toggle
          [value]="amountVariantEnum.deal"
          (change)="setDealAmount()">
          <span class="category">{{
            'schedule-payment.component.close_and_pay_deal_button'
              | localise: 'Close and Pay Deal'
          }}</span>
          <span class="value">{{
            dealAmount | currencyJs: { showSymbol: true }
          }}</span>
        </mat-button-toggle>
        @if (fullAmount.value !== dealAmount.value) {
          <mat-button-toggle
            [value]="amountVariantEnum.full"
            (change)="setFullBalanceAmount()">
            <span class="category">{{
              'schedule-payment.component.pay_all_balances_outstanding_button'
                | localise: 'Pay All Balances Outstanding'
            }}</span>
            @if (fullAmount) {
              <span class="value">{{
                fullAmount | currencyJs: { showSymbol: true }
              }}</span>
            }
          </mat-button-toggle>
        }
        <mat-button-toggle
          class="mat-button-toggle--bottom"
          (change)="onAmountVariantCustom()"
          [value]="amountVariantEnum.custom">
          <span class="category"
            >{{
              'schedule-payment.component.other_amount_button'
                | localise: 'Other Amount'
            }}
            @if (form.controls.amount.errors?.error) {
              <mat-hint class="input-hint warn-hint">{{
                form.controls.amount.errors?.error
              }}</mat-hint>
            }
          </span>
          @if (amountVariant === amountVariantEnum.custom) {
            <app-currency-input
              #amountInput
              classes="currency-input"
              formControlName="amount"
              [readonly]="
                (workloadIndicator.isLoading | async) === true
              "></app-currency-input>
          }
          @if (amountVariant !== amountVariantEnum.custom) {
            <mat-form-field class="skip-events">
              <mat-label
                >{{
                  'schedule-payment.component.enter_label' | localise: 'Enter'
                }}
              </mat-label>
              <span matPrefix>{{
                'schedule-payment.component.dollar_label' | localise: '$ &nbsp;'
              }}</span>
              <input type="text" matInput placeholder="0" />
            </mat-form-field>
          }
        </mat-button-toggle>
      </mat-button-toggle-group>
      <p>
        <strong>{{
          'schedule-payment.component.select_account'
            | localise: 'Select Account'
        }}</strong>
      </p>
      <mat-radio-group
        aria-label="Select Account"
        (change)="changedBankAccount($event)"
        formControlName="bankAccountId"
        #bankAccountInput>
        @for (item of bankList; track item) {
          <mat-radio-button [value]="item.id" [value]="item.id">
            {{ item.institution }}
            {{ item.accountNumber | removeSubstring: '*' }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <!--      <mat-form-field appearance="fill">-->
      <!--        <mat-select formControlName="bankAccountId" #bankAccountInput>-->
      <!--          <mat-option *ngFor="let item of bankList" [value]="item.id">-->
      <!--            Account # {{item.accountNumber}}-->
      <!--            at {{item.institution}}-->
      <!--          </mat-option>-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
      @if (bankMap[form.controls.bankAccountId.value]; as bankAccount) {
        @if (!!bankAccount?.plaidConnection?.disconnectedAt) {
          @if (bankAccount?.plaidConnection; as plaidConnection) {
            <div class="error-message-block">
              <p class="error-title">
                {{
                  'schedule-payment.component.plaid_error_connect_to_bank'
                    | localise: 'Cannot Connect to Bank!'
                }}
              </p>
              @if (plaidConnection?.isLoginRequired) {
                <span
                  >{{
                    'schedule-payment.component.plaid_error_connect_to_bank_text'
                      | localise
                        : 'There Was An Error Connecting Your Bank Account. Please '
                  }}
                  <a
                    (click)="close()"
                    routerLink="/bank-accounts"
                    [queryParams]="{ reconnect: bankAccount.id }"
                    >{{
                      'schedule-payment.component.plaid_error_connect_link'
                        | localise: 'Click Here'
                    }}</a
                  >
                  {{
                    'schedule-payment.component.plaid_error_connect_to_bank_text_2'
                      | localise: 'To Try To Reconnect It.'
                  }}
                </span>
              }
              @if (!plaidConnection?.isLoginRequired) {
                <span>
                  {{
                    'schedule-payment.component.plaid_error_connect_to_bank_text'
                      | localise
                        : 'There Was An Error Connecting Your Bank Account. Please '
                  }}
                  <a (click)="close()" routerLink="/bank-accounts">{{
                    'schedule-payment.component.plaid_error_connect_link'
                      | localise: 'Click Here'
                  }}</a>
                  {{
                    'schedule-payment.component.plaid_error_connect_to_bank_delete_old_text'
                      | localise
                        : 'To Delete The Old Bank Account And Add A New One.'
                  }}
                </span>
              }
            </div>
          }
        }
      }
      <a mat-flat-button (click)="addNewBankAccount()">{{
        'schedule-payment.component.add_account_button'
          | localise: 'Add Account > '
      }}</a>
    </mat-dialog-content>
    @if (error) {
      <p class="p-error-message p-error-message--margin">
        {{ error }}
      </p>
    }
    <mat-dialog-actions class="payment-dialog__actions">
      <button
        mat-button
        type="button"
        class="dialog-button dialog-button--round"
        [disabled]="workloadIndicator.isLoading | async"
        (click)="setStep(stepEnum.Date)">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button
        mat-button
        type="button"
        class="dialog-button dialog-button--round dialog-button--primary"
        [disabled]="(workloadIndicator.isLoading | async) || form.invalid"
        (click)="setStep(stepEnum.Done)">
        @if (workloadIndicator.isLoading | async) {
          <mat-spinner class="loader" [diameter]="25"></mat-spinner>
        }
        @if (workloadIndicator.isNotLoading | async) {
          @if (workloadIndicator.isNotLoading | async) {
            <mat-icon>arrow_forward</mat-icon>
          }
        }
      </button>
    </mat-dialog-actions>
  }

  @if (step === stepEnum.Done) {
    <mat-dialog-content class="payment-dialog__body">
      <p>
        <strong>{{
          'schedule-payment.component.review_your_payment'
            | localise: 'Review Your Payment'
        }}</strong>
      </p>
      <ul class="payment-dialog__summary">
        @if (!withoutSelectingDeal) {
          <li>
            <span class="category">{{
              'schedule-payment.component.commission_item'
                | localise: 'Commission'
            }}</span>
            <span class="value">{{ dealDetails.line1Address }}</span>
          </li>
        }
        <li>
          <span class="category">{{
            'schedule-payment.component.payment_amount_item'
              | localise: 'Payment Amount'
          }}</span>
          <span class="value">{{
            form.controls.amount.value | currencyJs: { showSymbol: true }
          }}</span>
        </li>
        <li>
          <span class="category">{{
            'schedule-payment.component.scheduled_for_item'
              | localise: 'Scheduled For'
          }}</span>
          <span class="value">{{ form.controls.date.value | dateApp }}</span>
        </li>
        <li>
          <span class="category">{{
            'schedule-payment.component.account_item' | localise: 'Account'
          }}</span>
          <span class="value"
            >{{ selectedBankAccount.institution }}
            {{ selectedBankAccount.accountNumber | removeSubstring: '*' }}</span
          >
        </li>
      </ul>
    </mat-dialog-content>
    @if (error) {
      <p class="p-error-message p-error-message--margin">
        {{ error }}
      </p>
    }
    <mat-dialog-actions class="payment-dialog__actions">
      <button
        mat-button
        type="button"
        class="dialog-button dialog-button--round"
        [disabled]="workloadIndicator.isLoading | async"
        (click)="setStep(stepEnum.Amount)">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button
        mat-button
        cdkFocusInitial
        type="button"
        class="dialog-button dialog-button--primary"
        [disabled]="workloadIndicator.isLoading | async"
        (click)="send()">
        <span>{{
          'schedule-payment.component.schedule_payment_button'
            | localise: 'Schedule Payment'
        }}</span>
      </button>
    </mat-dialog-actions>
  }
</form>
